module.exports = __webpack_public_path__ + "img/photo-4-2.4408e1d8.jpg";